/* global MatgenGlobal, $ */

import MatgenUIFunctions from './ui/ui-functions.js';

async function openEditorWorkspace(action) {
  MatgenGlobal.UI.loading('Loading editor workspace...');
  try {
    await MatgenGlobal.loadEditorWorkspace();
    action();
  } catch (error) {
    console.error('Unable to load the editor workspace', error);
    MatgenGlobal.UI.stopLoading();
    MatgenGlobal.UI.alertModal(
      'Editor unavailable',
      '<p>The editor workspace could not be loaded. Please refresh the page and try again.</p>'
    );
  }
}

export default {
  home: {
    hash: 'home',
    route: '/home',
    action: () => {
      if (!MatgenGlobal.AuthUser.user) {
        MatgenGlobal.Router.goTo('/unauth');
        return;
      }

      // Keep existing bookmarks working without retaining a separate
      // overview page.
      MatgenGlobal.Router.goTo(
        MatgenGlobal.AuthUser.getUserRole() === 'user'
          ? '/materials'
          : '/templates',
        true
      );
    },
  },
  test: {
    hash: 'test',
    route: '/test',
    action: () => {
      MatgenGlobal.UI.showPage(
        '<div id="test-div" style="width:250px;margin:auto;"></div><div id="test-div-2" style="width:250px;margin:auto;"></div>'
      );
    },
  },
  templates: {
    hash: 'templates',
    route: '/templates',
    action: async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const tenant_id = urlParams.get('tenant_id');
      if (!MatgenGlobal.AuthUser.user) {
        if (
          MatgenGlobal.RootRoute &&
          typeof MatgenGlobal.RootRoute === 'function'
        ) {
          MatgenGlobal.RootRoute();
        } else {
          MatgenGlobal.Router.goTo('/unauth');
        }
      } else if (tenant_id) {
        await MatgenGlobal.loadTable('MaterialTemplateTable');
        MatgenGlobal.UI.showPage(
          MatgenGlobal.Tables.MaterialTemplateTable.getHTML(),
          async () => {
            MatgenGlobal.UI.loading('Loading template table data...');
            const data = MatgenGlobal.Data.getTemplates(tenant_id);

            //console.log(data);
            MatgenGlobal.Tables.MaterialTemplateTable.load(data);
          }
        );
      } else {
        if (
          MatgenGlobal.AuthUser.user &&
          MatgenGlobal.AuthUser.getUserRole() === 'user'
        ) {
          MatgenGlobal.Router.goTo('/materials');
        } else {
          await MatgenGlobal.loadTable('TemplateTable');
          MatgenGlobal.UI.showPage(
            MatgenGlobal.Tables.TemplateTable.getHTML(),
            () => {
              if (
                MatgenGlobal.AuthUser.getUserRole() === 'admin' &&
                MatgenGlobal.Tables.TemplateTable.columns.findIndex(
                  c => c.data === 'tenant_name'
                ) >= 0
              ) {
                MatgenGlobal.Tables.TemplateTable.columns.splice(
                  MatgenGlobal.Tables.TemplateTable.columns.findIndex(
                    c => c.data === 'tenant_name'
                  ),
                  1
                );
                MatgenGlobal.Tables.TemplateTable.columns.find(
                  c => c.data === 'id'
                ).visible = false;
              }
              MatgenGlobal.Tables.TemplateTable.load();
            }
          );
        }
      }
    },
  },
  tenants: {
    hash: 'tenants',
    route: '/tenants',
    action: async () => {
      if (!MatgenGlobal.AuthUser.user) {
        if (
          MatgenGlobal.RootRoute &&
          typeof MatgenGlobal.RootRoute === 'function'
        ) {
          MatgenGlobal.RootRoute();
        } else {
          MatgenGlobal.Router.goTo('/unauth');
        }
      } else if (
        MatgenGlobal.AuthUser.user &&
        MatgenGlobal.AuthUser.getUserRole() === 'user'
      ) {
        MatgenGlobal.Router.goTo('/materials');
      } else {
        //TODO
        await MatgenGlobal.loadTable('TenantTable');
        MatgenGlobal.UI.showPage(
          MatgenGlobal.Tables.TenantTable.getHTML(),
          () => {
            MatgenGlobal.Tables.TenantTable.load();
          }
        );
      }
    },
  },
  questionnaire: {
    hash: 'questionnaires',
    route: '/questionnaires',
    action: async () => {
      if (!MatgenGlobal.AuthUser.user) {
        if (
          MatgenGlobal.RootRoute &&
          typeof MatgenGlobal.RootRoute === 'function'
        ) {
          MatgenGlobal.RootRoute();
        } else {
          MatgenGlobal.Router.goTo('/unauth');
        }
      } else if (
        MatgenGlobal.AuthUser.user &&
        MatgenGlobal.AuthUser.getUserRole() === 'user'
      ) {
        MatgenGlobal.Router.goTo('/materials');
      } else {
        //TODO
        await MatgenGlobal.loadTable('QuestionnaireTable');
        MatgenGlobal.UI.showPage(
          MatgenGlobal.Tables.QuestionnaireTable.getHTML(),
          () => {
            MatgenGlobal.Tables.QuestionnaireTable.load();
          }
        );
      }
    },
  },
  section: {
    hash: 'sections',
    route: '/sections',
    action: async () => {
      if (!MatgenGlobal.AuthUser.user) {
        if (
          MatgenGlobal.RootRoute &&
          typeof MatgenGlobal.RootRoute === 'function'
        ) {
          MatgenGlobal.RootRoute();
        } else {
          MatgenGlobal.Router.goTo('/unauth');
        }
      } else if (
        MatgenGlobal.AuthUser.user &&
        MatgenGlobal.AuthUser.getUserRole() === 'user'
      ) {
        MatgenGlobal.Router.goTo('/materials');
      } else {
        //TODO
        await MatgenGlobal.loadTable('SectionsTable');
        MatgenGlobal.UI.showPage(
          MatgenGlobal.Tables.SectionsTable.getHTML(),
          () => {
            MatgenGlobal.Tables.SectionsTable.load();
          }
        );
      }
    },
  },
  questions: {
    hash: 'questions',
    route: '/questions',
    action: async () => {
      if (!MatgenGlobal.AuthUser.user) {
        if (
          MatgenGlobal.RootRoute &&
          typeof MatgenGlobal.RootRoute === 'function'
        ) {
          MatgenGlobal.RootRoute();
        } else {
          MatgenGlobal.Router.goTo('/unauth');
        }
      } else if (
        MatgenGlobal.AuthUser.user &&
        MatgenGlobal.AuthUser.getUserRole() === 'user'
      ) {
        MatgenGlobal.Router.goTo('/materials');
      } else {
        //TODO
        await MatgenGlobal.loadTable('QuestionsTable');
        MatgenGlobal.UI.showPage(
          MatgenGlobal.Tables.QuestionsTable.getHTML(),
          () => {
            MatgenGlobal.Tables.QuestionsTable.load();
          }
        );
      }
    },
  },
  answers: {
    hash: 'answers',
    route: '/answers',
    action: async () => {
      if (!MatgenGlobal.AuthUser.user) {
        if (
          MatgenGlobal.RootRoute &&
          typeof MatgenGlobal.RootRoute === 'function'
        ) {
          MatgenGlobal.RootRoute();
        } else {
          MatgenGlobal.Router.goTo('/unauth');
        }
      } else if (
        MatgenGlobal.AuthUser.user &&
        MatgenGlobal.AuthUser.getUserRole() === 'user'
      ) {
        MatgenGlobal.Router.goTo('/materials');
      } else {
        //TODO
        await MatgenGlobal.loadTable('AnswersTable');
        MatgenGlobal.UI.showPage(
          MatgenGlobal.Tables.AnswersTable.getHTML(),
          () => {
            MatgenGlobal.Tables.AnswersTable.load();
          }
        );
      }
    },
  },
  templateSummary: {
    hash: 'template-summary',
    route: '/template-summary',
    action: async () => {
      await Promise.all([
        MatgenGlobal.loadTable('MaterialTemplateTable'),
        MatgenGlobal.loadTable('TemplateSummaryTable'),
      ]);
      MatgenGlobal.UI.showPage(
        MatgenGlobal.Tables.MaterialTemplateTable.getHTML(),
        async () => {
          MatgenGlobal.UI.loading('Loading template table data...');
          const data = await MatgenGlobal.Data.getTemplates();
          //console.log(data);
          MatgenGlobal.Tables.TemplateSummaryTable.load(data);
        }
      );
    },
  },
  users: {
    hash: 'users',
    route: '/users',
    action: async () => {
      MatgenGlobal.Router.core.emitRouteEvent('users');
      if (
        MatgenGlobal.AuthUser.user &&
        MatgenGlobal.AuthUser.getUserRole() === 'user'
      ) {
        MatgenGlobal.Router.goTo('/materials');
      } else {
        await MatgenGlobal.UI.userManagement();
      }
    },
  },
  agreementReport: {
    hash: 'cognito-agreement-report',
    route: '/cognito-agreement-report',
    action: async () => {
      MatgenGlobal.Router.core.emitRouteEvent('cognito-agreement-report');
      if (
        MatgenGlobal.AuthUser.user &&
        MatgenGlobal.AuthUser.getUserRole() === 'user'
      ) {
        MatgenGlobal.Router.goTo('/materials');
      } else {
        await MatgenGlobal.UI.agreementReport();
      }
    },
  },
  templateEdit: {
    hash: 'templates/:id',
    route: '/templates/:id',
    after: () => {
      $(MatgenGlobal.ControllerTargetSelector).addClass('editor');
    },
    leave: done => {
      $(MatgenGlobal.ControllerTargetSelector).removeClass('editor');
      $('#sidebar').remove();
      done();
    },
    action: req =>
      openEditorWorkspace(() => MatgenGlobal.UI.showTemplateEditor(req.id)),
  },
  tenantEdit: {
    hash: 'tenant/:id',
    route: '/tenant/:id',
    action: req =>
      openEditorWorkspace(() => MatgenGlobal.UI.showTenantEditor(req.id)),
  },
  tenantQuestionnaire: {
    hash: 'tenant-questionnaire',
    route: '/tenant-questionnaire',
    action: () => MatgenUIFunctions.createQuestionnaire(),
  },
  editQuestionnaire: {
    hash: 'edit-questionnaire/:id',
    route: '/edit-questionnaire/:id',
    action: req => MatgenUIFunctions.editQuestionnaire(req.id),
  },
  tags: {
    hash: 'tags/:id',
    route: '/tags/:id',
    action: req =>
      openEditorWorkspace(() => MatgenGlobal.UI.loadTagger(req.id)),
  },
  inspector: {
    hash: 'inspect/:id',
    route: '/inspect/{id}',
    action: req =>
      openEditorWorkspace(() => MatgenGlobal.UI.loadInspector(req.id)),
  },
  optionOrder: {
    hash: 'option-order/:id',
    route: '/option-order/{id}',
    action: req =>
      openEditorWorkspace(() => MatgenGlobal.UI.loadOptionSort(req.id)),
  },
  materials: {
    hash: 'materials',
    route: '/materials',
    action: async () => {
      if (MatgenGlobal.AuthUser && MatgenGlobal.AuthUser.user) {
        MatgenGlobal.Router.core.emitRouteEvent('materials');

        await MatgenGlobal.loadTable('MaterialTable');

        MatgenGlobal.UI.showPage(
          MatgenGlobal.Tables.MaterialTable.getHTML(),
          () => {
            MatgenGlobal.Tables.MaterialTable.load();
          }
        );
      } else {
        MatgenGlobal.Router.goTo('unauth');
      }
    },
  },
  microsites: {
    hash: 'microsites',
    route: '/microsites',
    action: async () => {
      MatgenGlobal.Router.core.emitRouteEvent('microsites');
      /*if (MatgenGlobal.AuthUser.getUserRole() !== 'user') {
        MatgenGlobal.Router.goTo('/materials');
      } else {*/
      await MatgenGlobal.loadTable('MicrositeTable');
      MatgenGlobal.UI.showPage(
        MatgenGlobal.Tables.MicrositeTable.getHTML(),
        () => {
          MatgenGlobal.Tables.MicrositeTable.load();
        }
      );
      //}
    },
  },
  materialEdit: {
    hash: 'materials/:id',
    route: '/materials/:id',
    action: req =>
      openEditorWorkspace(() => MatgenGlobal.UI.showMaterialEditor(req.id)),
  },
  unauth: {
    hash: 'unauth',
    route: '/unauth',
    action: () => MatgenGlobal.UI.unauth(),
  },
  /*login: {
    hash: 'login',
    route: '/login',
    action: () => MatgenGlobal.UI.login(),
  },
  logout: {
    hash: 'logout',
    route: '/logout',
    action: () => MatgenGlobal.AuthUser.signOut(),
  },*/
  appError: {
    hash: 'error',
    route: '/error',
    action: () => MatgenGlobal.UI.appError(),
  },
  //Catchall has to be last for hash router
  /*notFound: {
    hash: '*',
    route: '/404',
    action: () => MatgenGlobal.UI.notFound(),
  },*/
};
